import HeaderComponent from "./HeaderComponent";
import SidebarComponent from "./SidebarComponent";
const LayoutComponent = (props) => {
  return (
    <>
      <HeaderComponent />
      <div className="row mx-0">
        <SidebarComponent />
        <div className="col-lg-10 px-0">{props.children}</div>
      </div>
    </>
  );
};

export default LayoutComponent;
